import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../contexts/ContentContext';

const Services = () => {
  const { getContent } = useContent();
  const pageHeader = getContent('services.pageHeader');
  const mainServices = getContent('services.mainServices');
  const cta = getContent('services.cta');

  return (
    <div className="services-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="page-header-content">
            <h1>{pageHeader?.title || 'Nos Services'}</h1>
            <p>{pageHeader?.subtitle || '4 secteurs d\'excellence pour votre développement professionnel'}</p>
          </div>
        </div>
      </section>

      {/* Services Sections with Image + Text Block Layout */}
      {(mainServices?.services || [
        {
          id: "seminaires",
          title: "Séminaires",
          icon: "fas fa-chalkboard-teacher",
          image: "",
          description: "Sessions intensives et conférences spécialisées animées par des experts internationaux",
          features: ["Conférences d'experts internationaux", "Sessions interactives et discussions", "Mise à jour des dernières techniques", "Certificat de participation"],
          color: "blue"
        },
        {
          id: "formation",
          title: "Formation",
          icon: "fas fa-graduation-cap",
          image: "",
          description: "Programmes de formation complète avec certification professionnelle",
          features: ["Formations certifiantes complètes", "Apprentissage théorique et pratique", "Suivi personnalisé", "Diplôme reconnu internationalement"],
          color: "green"
        },
        {
          id: "coaching",
          title: "Coaching",
          icon: "fas fa-user-tie",
          image: "",
          description: "Accompagnement personnalisé pour développer votre expertise",
          features: ["Accompagnement individuel", "Plan de développement personnalisé", "Mentorat par des experts", "Suivi continu de progression"],
          color: "purple"
        },
        {
          id: "consulting",
          title: "Consulting",
          icon: "fas fa-handshake",
          image: "",
          description: "Conseil stratégique pour optimiser votre pratique dentaire",
          features: ["Audit de votre pratique", "Optimisation des processus", "Stratégies d'amélioration", "Support technique continu"],
          color: "orange"
        }
      ]).map((service, index) => (
        <section key={service.id} className={`service-block service-block-${service.color}`} id={service.id}>
          <div className="container">
            <div className={`service-image-text ${index % 2 === 0 ? '' : 'reverse'}`}>
              {/* Image Side */}
              <div className="service-image">
                {service.image ? (
                  <img src={service.image} alt={service.title} />
                ) : (
                  <div className="service-image-placeholder">
                    <i className={service.icon || 'fas fa-star'}></i>
                  </div>
                )}
              </div>

              {/* Text Side */}
              <div className="service-text">
                <h2>{service.title}</h2>
                <p className="service-description">{service.description}</p>
                
                <div className="service-features">
                  <h3>Ce que vous obtenez :</h3>
                  <ul className="features-list">
                    {(service.features || []).map((feature, featureIndex) => (
                      <li key={featureIndex}>
                        <i className="fas fa-check-circle"></i>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="service-actions">
                  {service.id === 'formation' ? (
                    <Link to="/formations#formations-grid-section" className="btn btn-primary">
                      <i className="fas fa-graduation-cap"></i>
                      Voir nos Formations
                    </Link>
                  ) : service.id === 'coaching' ? (
                    <Link to="/experts#expert-team" className="btn btn-primary">
                      <i className="fas fa-users"></i>
                      Liste de Coaching
                    </Link>
                  ) : service.id === 'consulting' ? (
                    <Link to="/experts#expert-team" className="btn btn-primary">
                      <i className="fas fa-users"></i>
                      Liste de Coaching
                    </Link>
                  ) : (
                    <a href={`https://wa.me/213797607481?text=Bonjour, je suis intéressé(e) par vos services de ${service.title.toLowerCase()}`} 
                       className="btn btn-primary" 
                       target="_blank" 
                       rel="noopener noreferrer">
                      <i className="fab fa-whatsapp"></i>
                      Contactez-nous
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* Call to Action */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>{cta?.title || 'Prêt à Commencer Votre Développement ?'}</h2>
            <p>{cta?.subtitle || 'Choisissez le service qui correspond le mieux à vos besoins et objectifs professionnels'}</p>
            <div className="cta-buttons">
              {(cta?.buttons || []).map((button, index) => (
                button.link?.startsWith('http') ? (
                  <a key={index}
                     href={button.link} 
                     className={`btn btn-${button.type}`}
                     target="_blank" 
                     rel="noopener noreferrer">
                    <i className={button.icon}></i>
                    {button.text}
                  </a>
                ) : (
                  <Link key={index} to={button.link} className={`btn btn-${button.type}`}>
                    <i className={button.icon}></i>
                    {button.text}
              </Link>
                )
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;

